/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2019-11-15 09:29:32
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2019-11-15 09:46:15
 */
import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import app from './modules/app';
import station from './modules/station';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    app,
    station
  }
});
